import './index.scss'
import { useDispatch } from 'stimulus-use'
import ApplicationController from '@app/javascript/controllers/application_controller'

export class Controller extends ApplicationController {
  static targets = ['quickFilter']

  doConnect() {
    useDispatch(this)
  }
}
